var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('svg',{staticClass:"animate-spin h-5 w-5 mr-3 fill-current inline",attrs:{"viewBox":"0 0 24 24"}},[_c('circle',{attrs:{"cx":"8","cy":"12","r":"3"}}),_c('circle',{attrs:{"cx":"16","cy":"12","r":"3"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }